export const Util = {
  getHeader(body) {
    return {
      type: 'application',
      name: body.filter((r) => r.name.includes('header'))[0].name
    }
  },

  getFooter(body) {
    return {
      type: 'application',
      name: body.filter((r) => r.name.includes('footer'))[0].name
    }
  },

  getRoutesDef() {
    return {
      mode: 'history',
      base: '/',
      disableWarnings: false,
      containerEl: 'main',
      routes: []
    }
  },

  getParameterByName(name: string): string {
    const url: string = window.location.href
    name = name.replace(/[[]]/g, '$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results: RegExpExecArray = regex.exec(url)
    if (!results) {
      return null
    }
    if (!results[2]) {
      return ''
    }
    return decodeURIComponent(results[2].replace('/+/g', ' '))
  },

  openInTab(href: string): void {
    Object.assign(document.createElement('a'), {
      href
    }).click()
  },

  validarEsIframe(){
    return this.getParameterByName('iframe') == '1'

  },

  registrarMicrofronts(routesDef, loaders, body) {
    const header = this.getHeader(body)
    const footer = this.getFooter(body)

    // Para invocar el appshell sin footer ni header se debe pasar por url el paramtro iframe = 1 de la siguiente forma "?iframe=1"
    // Esta característica es útil cuando se invoca a un inframe dentro del mismo sitio
    const isIframe = this.getParameterByName('iframe') == '1'

    this.setBackground(isIframe)

    if(isIframe){
     document.getElementById("qservus-widget-container").style.visibility = "hidden";
    }

    if (!isIframe) {
      routesDef.routes.push(header)
    } // Agregua el header si la ruta no es un iframe

    body.forEach((r) => {
      if (!r.name.includes('header') && !r.name.includes('footer')) {
        routesDef.routes.push({
          type: 'route',
          path: r.name.includes('home') ? '#/' : `#/${r.route}`,
          routes: [
            {
              type: 'application',
              name: r.name
            }
          ]
        })
      }
      loaders.push({ name: r.name, loader: r.appName })
    })

    if (!isIframe) {
      routesDef.routes.push(footer)
    } // Agrega el footer si no es un iframe

    return {
      routesDef,
      loaders
    }
  },

  setBackground(isIframe) {
    try {
      if (isIframe) {
        const html: HTMLHtmlElement = document.querySelector('html')
        html.style.backgroundColor = '#f0f0f0'
      }
    } catch (e) {
      console.log(e)
    }
  },

  getCookie(name: string): string | null {
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split('=');
      if (key === name) return value;
    }

    return null;
  },
  
  deleteCookie(name: string) {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.factoringsecurity.cl; SameSite=Lax`;
  },
}
